export default __webpack_public_path__ + "25395685efb438d6f33c883ea08c007f.svg";